module.exports = __webpack_public_path__ + "img/mvuk-logo-head.b86ab7e0.png";